import { Component } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-delete-product-cart',
  templateUrl: './delete-product-cart.page.html',
  styleUrls: ['./delete-product-cart.page.scss'],
})
export class DeleteProductCartPage {

  constructor(private modalCtrl: ModalController) { }
  
  public onCancel() {
    this.modalCtrl.dismiss(false);
  }
  
  public onConfirmDelete() {
    this.modalCtrl.dismiss(true);
  }

}
